import jwtDecode from 'jwt-decode'

const ACCESS_TOKEN = 'confiaCar.AccessToken'
const USER = 'confiaCar.User'

const getToken = () => getTokenDecoded()
const setToken = (token) => localStorage.setItem(ACCESS_TOKEN, token)
const cleanToken = () => localStorage.removeItem(ACCESS_TOKEN)

const getTokenDecoded = () => {
  let token = localStorage.getItem(ACCESS_TOKEN)
  const decodedToken = token ? jwtDecode(token) : null
  if (!decodedToken) {
    return null
  }
  const expirationTime = decodedToken.exp * 1000
  if (Date.now() > expirationTime) {
    console.error('expired token')
    cleanToken()
  }
  return localStorage.getItem(ACCESS_TOKEN)
}

const getUser = () => {
  let user = localStorage.getItem(USER)
  return JSON.parse(user)
}

const setUser = (user) => {
  let param = JSON.stringify(user)
  localStorage.setItem(USER, param)
}

const cleanUser = () => localStorage.removeItem(USER)

export { getToken, setToken, cleanToken, getUser, setUser, cleanUser }
